module.exports = __webpack_public_path__ + "static/media/xp_icon.09c2b97f.svg";